import 'globals';

(function(window) {
    /**
     * Triggers event on the window if the width or the height was changed
     */
    class SizeChanged {
        static widthChangedEvent = new Event('widthChange');
        static heightChangedEvent = new Event('heightChange');

        #currentWidth = undefined;
        #currentHeight = undefined;

        constructor() {
            this.#updateWidths();
            this.#initEventListener();
        }

        #updateWidths() {
            this.#currentWidth = document.documentElement.clientWidth;
            this.#currentHeight = document.documentElement.clientHeight;
        }

        /**
         * Returns the width of the viewport (document-element)
         * Equals to `$(window).width()`
         *
         * @return {number}
         */
        static get clientWidth() {
            return document.documentElement.clientWidth;
        }

        /**
         * Returns the height of the viewport (document-element)
         * Equals to `$(window).height()`
         *
         * @return {number}
         */
        static get clientHeight() {
            return document.documentElement.clientHeight;
        }

        /**
         * Initializes all Event-Listeners
         */
        #initEventListener() {
            window.addEventListener('resize', () => {
                this.#fireWidthChangedEvent();
                this.#fireHeightChangedEvent();
                this.#updateWidths();
            }, {passive: true});
        }

        /**
         * Fires the Event `widthChange` if the width was changed
         */
        #fireWidthChangedEvent() {
            if (this.#currentWidth !== SizeChanged.clientWidth) {
                window.dispatchEvent(SizeChanged.widthChangedEvent);
            }
        }

        /**
         * Fires the Event `heightChange` if the height was changed
         */
        #fireHeightChangedEvent() {
            if (this.#currentHeight !== SizeChanged.clientHeight) {
                window.dispatchEvent(SizeChanged.heightChangedEvent);
            }
        }
    }

    window.SizeChanged = new SizeChanged();
})(window);
